import React, { useState, useEffect } from "react";
import CardContainer from "../../components/card/card-container.jsx";
import LabelNumber from "../../components/label/label-number.jsx";
import Api from "../../api/global.service";
import { useAuth } from "../../components/content/auth.jsx";
import env from "../../environment.js";
import NoPagination from "../../components/pagination/noPagination.jsx";
import LinkDownload from "../../components/link/link-download.jsx";
import { useHistory } from "react-router-dom";
import { useCoopConfig } from "../../components/content/coop-config.jsx";
import CardProductor from "./components/card-productor.jsx";
import CardProductorHuertas from "./components/card-productor-huertas.jsx";
import Select, { components } from "react-select";
import { useForm} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import FormInputMaterialTest from "../../nuup/componentes/Forms/FormInputMaterialTest.jsx";
import FormSelectMaterialApi from "../../nuup/componentes/Forms/FormSelectMaterialApi.jsx";
import { getCalidadLS } from "./components/helpers.js";
import CardLocalidad from "./components/card-localidad.jsx";
import CardLote from "./components/card-lote.jsx";
import CheckboxList from '../../components/forms/checkbox-list.jsx';
import {ReactHookFormSelect} from "../../nuup/componentes/Forms/ReactHookFormSelect.jsx";
import EntregasXProductorTable from "../acopios/entregas-x-productor-table.jsx";


const CalidadSeleccion = () => {
  const INF_OBLIGATORIA = "Información obligatoria";
  const queryParameters = new URLSearchParams(window.location.search);
  const history = useHistory();
  const redirect = history.location.state?.redirect;
  const auth = useAuth();
  const coopConfig = useCoopConfig();
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [ciclo, setCiclo] = useState({});
  const [blocking, setBlocking] = useState(false);
  const [idsSeleccionados, setIdsSeleccionados] = useState([]);
  const [selectedEntrega, setSelectedEntrega] = useState(null);
  const [cuentas, setCuentas] = useState([]);
  const [cuentasOriginal, setCuentasOriginal] = useState([]);
  const [dataLotes, setDataLotes] = useState([]);
  const [lotes, setLotes] = useState([]);
  const [idLote, setIdLote] = useState(Number(getCalidadLS("info_muestra.id_recoleccion_acopio") || 0));
  const [idCuenta, setIdCuenta] = useState(Number(getCalidadLS("info_muestra.id_cuenta") || 0));
  const [tipoAnalisis, setTipoAnalisis] = useState(Number(getCalidadLS("info_muestra.id_tipo_analisis") || 1)); // 1 productor 2 lote, etc
  const [analisisPorEntrega, setAnalisisPorEntrega] = useState(Number(getCalidadLS("info_muestra.analisis_por_entrega") || 1)); // 1 SI se selecciona entrega 2 NO se selecciona entrega
  const [idAcopio, setIdAcopio] = useState(getCalidadLS("info_muestra.id_acopio") || 0);
  const [idMunicipio, setIdMunicipio] = useState(Number(getCalidadLS("info_muestra.id_municipio") || 0));
  const [idLocalidad, setIdLocalidad] = useState(getCalidadLS("info_muestra.id_localidad") || "");
  const [errores, setErrores] = useState([]);

  const friendlyFieldLabel = {
    "info_muestra.id_tipo_muestra": "Tipo de muestra",
    "info_muestra.id_cuenta": "Cuenta del productor",
    "info_muestra.id_lote": "Lote",
    "info_muestra.id_acopio": "Entrega",
    "info_muestra.id_municipio": "Municipio",
    "info_muestra.id_localidad": "Localidad",
    general: "Validación",
  };



  const [formData] = useState({
    info_muestra: {
      id_calidad_analisis: getCalidadLS("info_muestra.id_calidad_analisis"),
      id_tipo_muestra: getCalidadLS("info_muestra.id_tipo_muestra"),
      id_calidad_analisis_fisico: getCalidadLS("info_muestra.id_calidad_analisis_fisico"),
      id_calidad_analisis_sensorial: getCalidadLS("info_muestra.id_calidad_analisis_sensorial"),
      id_cuenta: getCalidadLS("info_muestra.id_cuenta"),
      id_acopio: getCalidadLS("info_muestra.id_acopio"),
      id_lote: getCalidadLS("info_muestra.id_lote"),
      tipo_analisis: getCalidadLS("info_muestra.tipo_analisis"),
      analisis_por_entrega: getCalidadLS("info_muestra.analisis_por_entrega"),
      nombre_proveedor: getCalidadLS("info_muestra.nombre"),
      region_proveedor: getCalidadLS("info_muestra.region_proveedor"),
      notas_adicionales: getCalidadLS("info_muestra.notas_adicionales"),
      id_municipio: getCalidadLS("info_muestra.id_municipio"),
      id_localidad: getCalidadLS("info_muestra.id_localidad"),
    },
  });

  const schema = yup.object().shape({
    info_muestra: yup.object().shape({
      tipo_analisis: yup.number().min(1),
      id_tipo_muestra: yup
        .number()
        .min(1)
        .transform((value) => (isNaN(value) ? undefined : value))
        .required(INF_OBLIGATORIA),
      id_cuenta: yup
        .number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .nullable()
        .when("tipo_analisis", (tipo_analisis, schema) => {
          if (tipo_analisis === 1)
            return schema.min(1, INF_OBLIGATORIA).required(INF_OBLIGATORIA);
          return schema;
        }),
      id_lote: yup
        .number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .nullable()
        .when("tipo_analisis", (tipo_analisis, schema) => {
          if (tipo_analisis === 2)
            return schema.min(1, INF_OBLIGATORIA).required(INF_OBLIGATORIA);
          return schema;
        }),
      analisis_por_entrega: yup
        .number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .nullable(),
      id_acopio: yup
        .string()
        .nullable()
        .when(["tipo_analisis", "analisis_por_entrega"], (tipo_analisis,analisis_por_entrega, schema) => {
          if (+tipo_analisis === 1 && +analisis_por_entrega === 1) {
            return schema.required(INF_OBLIGATORIA);
          }
          return schema;
        }),
      id_municipio: yup
        .number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .nullable()
        .when("tipo_analisis", (tipo_analisis, schema) => {
          if (tipo_analisis === 3)
            return schema.min(1, INF_OBLIGATORIA).required(INF_OBLIGATORIA);
          return schema;
        }),
      nombre_proveedor: yup
        .string()
        .nullable()
        .when("tipo_analisis", (tipo_analisis, schema) => {
          if (tipo_analisis === 4) return schema.nullable();
          return schema;
        }),
      region_proveedor: yup
        .string()
        .nullable()
        .when("tipo_analisis", (tipo_analisis, schema) => {
          if (tipo_analisis === 4) return schema.nullable();
          return schema;
        }),
      notas_adicionales: yup
        .string()
        .nullable()
        .when("tipo_analisis", (tipo_analisis, schema) => {
          if (tipo_analisis === 4) return schema.nullable();
          return schema;
        }),
      id_localidad: yup
        .string()
        .nullable()
        .when("tipo_analisis", (tipo_analisis, schema) => {
          if (tipo_analisis === 3) return schema.required(INF_OBLIGATORIA);
          return schema;
        }),
    }),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    watch,
    getValues,
    setError,
    clearErrors,
  } = useForm({
    resolver: async (data, context, options) => {
      return yupResolver(schema)(data, context, options);
    },
    mode: "onBlur",
    defaultValues: formData,
  });

  const tipoAnalisisWatch = watch("info_muestra.id_tipo_analisis");
  const analisisPorEntregaWatch = watch("info_muestra.analisis_por_entrega");
  const idAcopioWatch = watch("info_muestra.id_acopio");

  useEffect(() => {
    console.log("tipoAnalisisWatch", tipoAnalisisWatch);
    if (tipoAnalisisWatch !== undefined && tipoAnalisisWatch !== null) {
      setTipoAnalisis(Number(tipoAnalisisWatch));
    }
  }, [tipoAnalisisWatch]);

  useEffect(() => {
    if (analisisPorEntregaWatch !== undefined && analisisPorEntregaWatch !== null) {
      setAnalisisPorEntrega(Number(analisisPorEntregaWatch));
    }
  }, [analisisPorEntregaWatch]);

  // Preselecciona "¿La muestra es de una entrega determinada?" según id_acopio
  // Si existe id_acopio -> "Sí" (1). Si no existe -> "No" (2).
  useEffect(() => {
    // Nota: idAcopioWatch puede ser string (por compatibilidad histórica) o número
    const hasEntrega =
      idAcopioWatch !== undefined &&
      idAcopioWatch !== null &&
      String(idAcopioWatch).trim() !== "" &&
      Number(idAcopioWatch) > 0;
    const next = hasEntrega ? 1 : 2;
    setAnalisisPorEntrega(next);
    setValue("info_muestra.analisis_por_entrega", next);
  }, [idAcopioWatch, setValue]);

  // Preselecciona el checkbox de entregas usando selectedEntrega según id_acopio
  useEffect(() => {
    const hasEntrega =
      idAcopioWatch !== undefined &&
      idAcopioWatch !== null &&
      String(idAcopioWatch).trim() !== "" &&
      Number(idAcopioWatch) > 0;

    if (hasEntrega) {
      // Usar setSelectedEntrega para reflejar la selección en la tabla
      setSelectedEntrega({id_acopio: String(idAcopioWatch)});
    } else {
      setSelectedEntrega(null);
    }
  }, [idAcopioWatch]);

  const customStyles = {
    control: (base) => ({
      ...base,
      flexDirection: "row-reverse",
      width: "100%",
    }),
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: "#999",
        fontSize: 14,
      };
    },
    menu: (base) => ({
      ...base,
      zIndex: 999,
    }),
  };

  const DropdownIndicator = (props) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <i
            className="fa fa-search"
            aria-hidden="true"
            style={{ position: "initial" }}
          ></i>
        </components.DropdownIndicator>
      )
    );
  };

  const handleChange = (selected) => {
    setValue("info_muestra.id_cuenta", selected.value);
    setIdCuenta(selected.value);
    setValue("info_muestra.id_lote", "");
    setIdLote("");
  };

  const handleChangeLote = (selected) => {
    setValue("info_muestra.id_lote", selected.value);
    setIdLote(selected.value);
    setValue("info_muestra.id_cuenta", "");
    setIdCuenta("");
  };

  useEffect(() => {
    getProductores();
    getLotes();
  }, []);

  useEffect(() => {
    if (analisisPorEntrega === 1) {
      let values = getValues();
      if (idLote > 0) {
        // Buscar entregas por lote
        console.log("Buscar entregas por lote");
      }

      if (idCuenta > 0) {
        // Buscar entregas por cuenta
        updateData();
      }
    }
  }, [analisisPorEntrega, idCuenta, idLote]);

  // Sincroniza la selección de la tabla de entregas con el estado existente
  useEffect(() => {
    console.log("selectedEntrega");
    console.log(JSON.stringify(selectedEntrega));
    if (selectedEntrega && selectedEntrega.id_acopio != null) {
      // Asignamos id_tipo_cafe si es mayor a cero
      if (selectedEntrega.id_tipo_cafe > 0) {
        setValue('info_muestra.id_tipo_cafe',String(selectedEntrega.id_tipo_cafe));
      }
      // Asignamos peso_neto a peso asociado
      if (selectedEntrega.peso_neto > 0) {
        setValue('info_muestra.peso_asociado',selectedEntrega.peso_neto);
      }
      // Asignamos id_proceso a id_tipo_proceso
      if (selectedEntrega.id_proceso > 0) {
        setValue('info_muestra.id_tipo_proceso',String(selectedEntrega.id_proceso));
      }


      let idsSel = [selectedEntrega.id_acopio];
      setIdsSeleccionados(idsSel);
    } else {
      setIdsSeleccionados([]);
    }
  }, [selectedEntrega]);


  useEffect(() => {
    setValue('info_muestra.id_acopio','');
    if (idsSeleccionados.length > 0) {
      setValue('info_muestra.id_acopio',idsSeleccionados.join());
    }
  }, [idsSeleccionados]);


  const getProductores = () => {
    setBlocking(true);
    Api.search("cuentas", {
      filter: [
        {
          column: "id_ciclo",
          operator: "=",
          value: localStorage.getItem(`${env.appName}-ciclo_id`),
        },
      ],
    }).then((response) => {
      setCuentasOriginal(response.data);
      let _items = response.data.map(function(item) {
        return {
          value: item["id"],
          label: item["nombre"],
          uuid_cuenta: item["uuid"],
        };
      });
      setCuentas(_items);
      // Set initial value
      // eslint-disable-next-line eqeqeq
    });
  };

  const getLotes = () => {
    Api.get(
      "admin/acopios/entregas/lotes",
      localStorage.getItem(`${env.appName}-ciclo_id`),
      {}
    )
      .then((response) => {
        let lotes = response.data;
        let _lotes = response.data;
        setDataLotes(lotes);
        setLotes(
          lotes.map(function(lote) {
            return { label: lote.nombre, value: lote.id };
          })
        );
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
      });
  };

  const columnsLotes = React.useMemo(
    () => [
      {
        Header: "NOMBRE",
        accessor: "nombre",
        sortable: true,
        minWidth: 80,
      },
      {
        Header: "Nº O CÓDIGO",
        accessor: "folio",
        sortable: true,
        minWidth: 50,
        Cell: ({ value, row }) => {
          if (row.original.folio != null) {
            return value;
          } else {
            return "-";
          }
        },
      },
      {
        Header: "VOLUMEN A ENTREGAR",
        accessor: "volumen",
        sortable: true,
        minWidth: 50,
        Cell: ({ value, row }) => {
          if (row.original.volumen != null) {
            return (
              <LabelNumber
                value={value}
                currency={false}
                digits={2}
                position="text-left"
              ></LabelNumber>
            );
          } else {
            return "-";
          }
        },
      },
      {
        Header: "VOLUMEN ACOPIADO",
        accessor: "lote_kgs_entregados",
        sortable: true,
        minWidth: 50,
        Cell: ({ value, row }) => {
          if (row.original.lote_kgs_entregados != null) {
            return (
              <LabelNumber
                value={value}
                currency={false}
                digits={2}
                position="text-left"
              ></LabelNumber>
            );
          } else {
            return "-";
          }
        },
      },
      {
        Header: "AVANCE ACOPIO",
        accessor: "avance_acopio",
        sortable: true,
        minWidth: 50,
        Cell: ({ value, row }) => {
          let avance_por =
            (
              (Number(row.original.lote_kgs_entregados) /
                Number(row.original.volumen)) *
              100
            ).toFixed(2) + " %";
          if (row.original.volumen != null) {
            return (
              <LabelNumber
                value={avance_por}
                currency={false}
                suffix=" %"
                digits={2}
                position="text-left"
              ></LabelNumber>
            );
          } else {
            return "-";
          }
        },
      },
      {
        Header: "FECHA DE ENTREGA O VENTA",
        accessor: "fecha_entrega_venta",
        sortable: true,
        minWidth: 50,
        Cell: ({ value, row }) => {
          if (row.original.fecha_entrega_venta != null) {
            return value;
          } else {
            return "-";
          }
        },
      },
    ],
    []
  );

  const getBackgroundColor = (i, j) => {
    if (i == 1) {
      return "rgb(247, 239, 231)";
    } else {
      switch (j) {
        case 1:
          return "#91918A";
        case 3:
          return "#91918A";
        case 5:
          return "#91918A";
        case 7:
          return "#91918A";
        default:
          return env.colors.neutral_600;
      }
    }
  };

  const getColor = (i) => {
    return i == 1 ? "rgb(95, 95, 89)" : "white";
  };

  const setFilter = (value) => {
    setCiclo(value.target);
  };

  const updateData = () => {
    setBlocking(true);
    Api.Acopio.search("entregas_por_productor", {
      filter: [
        {
          column: "id_ciclo",
          operator: "=",
          value: localStorage.getItem(`${env.appName}-ciclo_id`),
        },
        { column: "id_cuenta", operator: "=", value: idCuenta },
      ],
    })
      .then((response) => {
        setData(response.data);
        setOriginalData(response.data);
        setBlocking(false);
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.log("error", e);
        setBlocking(false);
      });
  };

  const validateHandler = () => {
    var data = getValues();
    schema
      .validate(data, { abortEarly: false })
      .then(function(valid) {
        clearErrors();
        limpiaConfigAnalisis();
        history.push({
          pathname: "/admin/calidad/analisis/fisico/registro",
        });
      })
      .catch(function(err) {
        let errores = {};
        if (Array.isArray(err?.inner) && err.inner.length) {
          errores = err.inner.reduce(function(map, obj) {
            if (obj?.path && obj?.message) {
              setError(obj.path, { message: obj.message });
              map[obj.path] = obj.message;
            }
            return map;
          }, {});
        } else if (err?.path && err?.message) {
          setError(err.path, { message: err.message });
          errores[err.path] = err.message;
        } else {
          errores["general"] = err?.message || "Error al validar.";
        }
        setErrores(errores);
        setBlocking(false);
      });
  };

  /*
  useEffect(() => {
    watch(values => {
      validateHandler();
    });
  }, [watch]);
*/

  useEffect(() => {
    clearErrors();
    setErrores([]);
  }, [tipoAnalisis]);

  useEffect(() => {
    let tipoAnalisis = Number(getCalidadLS("info_muestra.id_tipo_analisis"));
    if (tipoAnalisis > 0) {
      setTipoAnalisis(tipoAnalisis);
      setValue("info_muestra.tipo_analisis", tipoAnalisis);
    }
    const ape = Number(getCalidadLS("info_muestra.analisis_por_entrega"));
    if (ape > 0) {
      setAnalisisPorEntrega(ape);
      setValue("info_muestra.analisis_por_entrega", ape);
    }
    switch (tipoAnalisis) {
      case 1:
        let id_cuenta = Number(getCalidadLS("info_muestra.id_cuenta"));
        setValue("info_muestra.id_cuenta", id_cuenta);
        setIdCuenta(id_cuenta);
        let id_acopio = getCalidadLS("info_muestra.id_acopio");
        if (typeof id_acopio === 'string' && id_acopio.length > 0) {
          setValue("info_muestra.id_acopio", id_acopio);
          setIdAcopio(id_acopio);
          setAnalisisPorEntrega(1);
          setIdsSeleccionados(id_acopio.split(","));
        }
        break;
      case 2:
        let id_lote = Number(getCalidadLS("info_muestra.id_recoleccion_acopio"));
        setValue("info_muestra.id_lote", id_lote);
        setIdLote(id_lote);
        break;
      case 3:
        let id_municipio = Number(getCalidadLS("info_muestra.id_municipio"));
        let id_localidad = getCalidadLS("info_muestra.id_localidad");
        setValue("info_muestra.id_municipio", id_municipio);
        setValue("info_muestra.id_localidad", id_localidad);
        setIdMunicipio(id_municipio);
        setIdLocalidad(id_localidad);
        break;
    }
  }, []);

  const limpiaConfigAnalisis = () => {
    // Leer configuración actual para preservar analisis_* y solo actualizar info_muestra
    const current = getCalidadLS() || {};
    const baseInfo = { ...(current.info_muestra || {}) };

    // Construir las actualizaciones de info_muestra según el tipo de análisis seleccionado
    const infoUpdates = {
      id_calidad_analisis: baseInfo.id_calidad_analisis,
      id_tipo_muestra: getValues()?.info_muestra?.id_tipo_muestra ?? baseInfo.id_tipo_muestra,
      id_tipo_cafe: getValues()?.info_muestra?.id_tipo_cafe ?? baseInfo.id_tipo_cafe,
      peso_asociado: getValues()?.info_muestra?.peso_asociado ?? baseInfo.peso_asociado,
      id_tipo_proceso: getValues()?.info_muestra?.id_tipo_proceso ?? baseInfo.id_tipo_proceso,
      id_calidad_analisis_fisico: baseInfo.id_calidad_analisis_fisico,
      id_calidad_analisis_sensorial: baseInfo.id_calidad_analisis_sensorial,
      id_cuenta: baseInfo.id_cuenta,
      id_acopio: baseInfo.id_acopio,
      id_lote: baseInfo.id_lote,
      tipo_analisis: tipoAnalisis,
      id_tipo_analisis: tipoAnalisis,
      analisis_por_entrega: baseInfo.analisis_por_entrega,
      id_ciclo: Number(localStorage.getItem(`${env.appName}-ciclo_id`) || 0) || '',
      nombre_proveedor: baseInfo.nombre_proveedor,
      region_proveedor: baseInfo.region_proveedor,
      notas_adicionales: baseInfo.notas_adicionales,
      id_municipio: baseInfo.id_municipio,
      id_localidad: baseInfo.id_localidad,
    };

    // Ajustes específicos por tipo de análisis
    switch (tipoAnalisis) {
      case 1:
        infoUpdates.id_cuenta = idCuenta;
        infoUpdates.analisis_por_entrega = analisisPorEntrega;
        infoUpdates.id_acopio = idsSeleccionados.join();
        // Al seleccionar cuenta, limpiar lote para evitar ambigüedad
        infoUpdates.id_lote = '';
        break;
      case 2:
        infoUpdates.id_lote = idLote;
        // Al seleccionar lote, limpiar cuenta/entregas
        infoUpdates.id_cuenta = '';
        infoUpdates.id_acopio = '';
        break;
      case 3:
        infoUpdates.id_municipio = idMunicipio;
        infoUpdates.id_localidad = (idLocalidad.charAt(0) === ',') ? idLocalidad.substring(1) : idLocalidad;
        // Limpiar cuenta/lote/entregas
        infoUpdates.id_cuenta = '';
        infoUpdates.id_lote = '';
        infoUpdates.id_acopio = '';
        break;
      case 4:
        infoUpdates.nombre_proveedor = getValues()?.info_muestra?.nombre_proveedor ?? baseInfo.nombre_proveedor;
        infoUpdates.region_proveedor = getValues()?.info_muestra?.region_proveedor ?? baseInfo.region_proveedor;
        infoUpdates.notas_adicionales = getValues()?.info_muestra?.notas_adicionales ?? baseInfo.notas_adicionales;
        // Limpiar cuenta/lote/entregas
        infoUpdates.id_cuenta = '';
        infoUpdates.id_lote = '';
        infoUpdates.id_acopio = '';
        break;
    }

    const merged = {
      ...current,
      info_muestra: {
        ...baseInfo,
        ...infoUpdates,
      },
      // Preservar analisis_* si ya existen
      analisis_fisico: current.analisis_fisico || {},
      analisis_oro: current.analisis_oro || {},
      analisis_sensorial: current.analisis_sensorial || {},
    };

    localStorage.setItem(`${env.appName}-calidad`, JSON.stringify(merged));
  };


  const handlerSelectChange = (value) => {
    setIdLocalidad(value.join());
    setValue("info_muestra.id_localidad", value.join());
  };


  const handleCheck = event => {
    const val = String(event.target.value);
    setIdsSeleccionados(prev => {
      if (event.target.checked) {
        if (prev.includes(val)) return prev;
        return [...prev, val];
      } else {
        return prev.filter(item => item !== val);
      }
    });
  };

  return (
    <div>
      <CardContainer height={"100%"} style={{ marginTop: 10 }}>
        <div className="row">
          <div className="col-md-12">
            <h5>{"Registro de análisis de muestra"}</h5>
          </div>
        </div>


        <div className="row mt-3" style={{ height: 60 }}>

          <div className="col-md-3">
          <ReactHookFormSelect
            placeholder="Tipo de muestra *"
            label="Tipo de muestra *"
            id={'info_muestra.id_tipo_muestra'}
            name={'info_muestra.id_tipo_muestra'}
            error={errors?.info_muestra?.id_tipo_muestra ? true : false}
            url={"calidad/catalogos/tipo_muestras"}
            keyArray="id"
            labelArray="nombre"
            register={register}
            apiSearch={false}
            control={control}
            value={getValues()?.info_muestra?.id_tipo_muestra}
          />
            {errors?.info_muestra?.id_tipo_muestra && (
              <div className="invalid-feedback">
                {errors?.info_muestra?.id_tipo_muestra.message}
              </div>
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-xl-2 col-lg-3">
            <input
              type="radio"
              name="info_muestra.tipo_analisis"
              value={1}
              checked={Number(tipoAnalisis) === 1}
              onChange={() => {
                setValue("info_muestra.tipo_analisis", 1);
                setTipoAnalisis(1);
              }}
            />{" "}
            <span style={{ fontSize: 16 }}>Por productor</span>
            <br />
            <input
              type="radio"
              name="info_muestra.tipo_analisis"
              value={2}
              checked={Number(tipoAnalisis) === 2}
              onChange={() => {
                setValue("info_muestra.tipo_analisis", 2);
                setTipoAnalisis(2);
                setIdCuenta("");
              }}
            />{" "}
            <span style={{ fontSize: 16 }}>Por lote</span>
          </div>
          <div className="col-xl-2 col-lg-3">
            <input
              type="radio"
              name="info_muestra.tipo_analisis"
              value={3}
              checked={Number(tipoAnalisis) === 3}
              onChange={() => {
                setValue("info_muestra.tipo_analisis", 3);
                setTipoAnalisis(3);
                setIdCuenta("");
              }}
            />{" "}
            <span style={{ fontSize: 16 }}>Por región</span>
            <br />
            <input
              type="radio"
              name="info_muestra.tipo_analisis"
              value={4}
              checked={Number(tipoAnalisis) === 4}
              onChange={() => {
                setValue("info_muestra.tipo_analisis", 4);
                setTipoAnalisis(4);
                setIdCuenta("");
              }}
            />{" "}
            <span style={{ fontSize: 16 }}>Otros proveedores</span>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-xl-6 col-lg-6 col-md-12">
            {tipoAnalisis === 1 && (
              <div className={errors?.info_muestra?.id_cuenta ? "danger" : null}>
                <Select
                  components={{ DropdownIndicator }}
                  styles={customStyles}
                  isClearable={true}
                  isSearchable={true}
                  placeholder="Seleccione productor"
                  noOptionsMessage={() => "No hay elementos por mostrar"}
                  options={cuentas}
                  value={
                    cuentas.filter(
                      (lote) => Number(lote.value) === Number(idCuenta)
                    )?.[0]
                  }
                  onChange={handleChange}
                />
              </div>
            )}
            {tipoAnalisis === 2 && (
              <div className={errors?.info_muestra?.id_lote ? "danger" : null}>
                <Select
                  components={{ DropdownIndicator }}
                  styles={customStyles}
                  isClearable={false}
                  isSearchable={true}
                  placeholder="Seleccione lote"
                  noOptionsMessage={() => "No hay elementos por mostrar"}
                  options={lotes}
                  value={
                    lotes.filter(
                      (lote) => Number(lote.value) === Number(idLote)
                    )?.[0]
                  }
                  onChange={handleChangeLote}
                />
              </div>
            )}
          </div>
        </div>

        {cuentasOriginal.filter((cuenta) => Number(cuenta.id) === Number(idCuenta)).length > 0 && (
          <div className="row mt-2">
            <div className="col-md-6">
              <CardProductor
                blocking={false}
                idCuenta={idCuenta}
                fotoURL={null}
                parcelas={1}
                hectareas={5}
                plantas={10}
              />
            </div>
            <CardProductorHuertas idCuenta={idCuenta} />
          </div>
        )}

        {idCuenta > 0 && (
          <>
            <div className="row">
              <div className="col-xl-6 col-lg-12">
                <p className="titulo-pregunta">
                  {"¿La muestra es de una entrega determinada?"}
                </p>
                <input
                  type="radio"
                  name="info_muestra.analisis_por_entrega"
                  value={2}
                  checked={Number(analisisPorEntrega) === 2}
                  onChange={() => {
                    setValue("info_muestra.analisis_por_entrega", 2);
                    setAnalisisPorEntrega(2);
                  }}
                />{" "}
                No
                <br />
                <input
                  type="radio"
                  name="info_muestra.analisis_por_entrega"
                  value={1}
                  checked={Number(analisisPorEntrega) === 1}
                  onChange={() => {
                    setValue("info_muestra.analisis_por_entrega", 1);
                    setAnalisisPorEntrega(1);
                  }}
                />{" "}
                Si
              </div>
            </div>

            {analisisPorEntrega === 1 && (
              <div className="row">
                <div className="col-md-12">
                  <EntregasXProductorTable
                    blocking={blocking}
                    selected="id"
                    data={data}
                    fnBackgroundColor={getBackgroundColor}
                    fnColor={getColor}
                    coopConfig={coopConfig}
                    selectedData={selectedEntrega}
                    setSelectedData={setSelectedEntrega}
                    isChecked={(row, selected) => {
                      return row?.id_acopio == selected?.id_acopio
                    }}
                  />
                </div>
              </div>
            )}
          </>
        )}

        {tipoAnalisis === 2 && (
          <div className="row mt-3">
            <div className="col-md-12">
              <NoPagination
                blocking={false}
                selected="id"
                columns={columnsLotes}
                data={dataLotes}
              />
              {idLote > 0 && (<CardLote idLote={idLote} />)}
            </div>
          </div>
        )}

        {tipoAnalisis === 3 && (
          <>
            <div className="row">
              <div className="col-xl-3 col-lg-6">
                <div className={errors?.info_muestra?.id_municipio ? "danger" : null}>
                  <FormSelectMaterialApi
                    id="info_muestra.id_municipio"
                    name="info_muestra.id_municipio"
                    label="Elige un municipio"
                    url={"cooperativas_municipios"}
                    keyArray="id"
                    labelArray="nombre"
                    placeholder="Elige un municipio"
                    register={register}
                    onChange={(e) => {
                      setIdMunicipio(e.target.value);
                      setValue("info_muestra.id_municipio", e.target.value);
                      handlerSelectChange([]);
                    }}
                    value={idMunicipio}
                    apiSearch={false}
                  />
                </div>
              </div>
              <div className="col-xl-3 col-lg-6">

                <FormSelectMaterialApi
                  placeholder="Elige una o varias localidades"
                  label="Elige una o varias localidades"
                  id="info_muestra.id_localidad"
                  name="info_muestra.id_localidad"
                  error={errors?.info_muestra?.id_localidad ? true : false}
                  url={"localidades_mununicipio/" + idMunicipio}
                  keyArray="id"
                  labelArray="nombre"
                  apiSearch={false}
                  register={register}
                  value={(getValues()?.info_muestra?.id_localidad ?? '').split(',')}
                  onChange={(e) => handlerSelectChange(e.target.value)}
                  multiple={true}
                />

              </div>
            </div>
            {idLocalidad.length > 0 && <CardLocalidad idLocalidad={idLocalidad} />}
          </>
        )}

        {tipoAnalisis === 4 && (
          <>
            <div className="row mt-3">
              <div className="col-md-3">
                <FormInputMaterialTest
                  type="text"
                  id="info_muestra.nombre_proveedor"
                  name="info_muestra.nombre_proveedor"
                  label=""
                  placeholder="Nombre del proveedor"
                  error={errors?.info_muestra?.nombre_proveedor}
                  register={register}
                  value={getValues()?.info_muestra?.nombre_proveedor}
                />
              </div>
              <div className="col-md-3">
                <FormInputMaterialTest
                  type="text"
                  id="info_muestra.region_proveedor"
                  name="info_muestra.region_proveedor"
                  label=""
                  placeholder="Región"
                  error={errors?.info_muestra?.region_proveedor}
                  register={register}
                  value={getValues()?.info_muestra?.region_proveedor}
                />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-10">
                <FormInputMaterialTest
                  type="text"
                  id="info_muestra.notas_adicionales"
                  name="info_muestra.notas_adicionales"
                  label=""
                  placeholder="Descripción / notas adicionales"
                  error={errors?.info_muestra?.notas_adicionales}
                  register={register}
                  value={getValues()?.info_muestra?.notas_adicionales}
                  multiline
                />
              </div>
            </div>
          </>
        )}



        {/* Mensajes de validación antes del botón Continuar */}
        <div className="row mt-4">
          <div className="col-md-12">
            {Object.entries(errores || {}).length > 0 && (
              <div className="alert alert-danger" role="alert">
                <p style={{ marginBottom: 10 }}>Por favor corrige los siguientes campos:</p>
                <ul style={{ paddingLeft: 18, marginBottom: 0 }}>
                  {Object.entries(errores).map(([path, msg], idx) => {
                    const label = friendlyFieldLabel[path] || path || "Campo";
                    return (
                      <li key={idx}>{`${label}: ${msg}`}</li>
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
        </div>

        <div className="row mt-5">
          <div className="col-md-12">
            <button
              style={{
                borderRadius: "20px 20px 20px 20px",
                color: "#333",
                fontWeight: "normal",
                fontSize: 16,
              }}
              className="btn btn-sirio"
              onClick={() => validateHandler()}
            >
               {'Continuar'} 
            </button>
          </div>
        </div>
      </CardContainer>
    </div>
  );
};

export default CalidadSeleccion;
